/* eslint-disable prettier/prettier */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import queryString from "query-string";
import React, { useEffect, useRef, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Helmet } from "react-helmet";
import { Button } from "@mui/material";
// import ExportButton from "../../../components/common/ExportButton/ExportButton";
import AppliedFilter from "../../../components/common/AppliedFilter/AppliedFilter";
import Loader from "../../../components/common/Loader/Loader";
import Modal from "../../../components/common/Modal/Modal";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import useUserConfig from "../../../hooks/useUserConfig";
import {
  DATES,
  EVENT_NAME,
  ACTIVE,
  Constants,
  AlertStatus,
} from "../../../contants";
// import { MEMBER_SEARCH_COL } from "../../../contants/table/memberSearch";
import useQueryParams from "../../../hooks/useQueryParams";
import { SET_SELECTED_MEMBER_TRANSFER } from "../../../redux/actionTypes/dashboard";
import {
  selectAllSIUsers,
  selectOSKeysByUserRole,
} from "../../../redux/selectors/user";
import Member from "../../../services/api/member";
import { ROUTES } from "../../../utils/constants";
import { formDataToObject, isEmptyObj } from "../../../utils/helper";
import AdvancedSearch from "./AdvancedSearch";
import styles from "./MemberSearch.styles";
import MemberTable from "./MemberTable/MemberTable";
import MemberToggleStatus from "./MemberToggleStatus/MemberToggleStatus";
import OrganizationSearch from "./OrganizationSearch";
import PersonalDetailsSearch from "./PersonalDetailsSearch";
import MemberDirectDeactivationHelpDesk from "./MemberToggleStatus/MemberDirectDeactivationHelpDesk";
import {
  getFilters,
  getFormattedQuery,
  getRoutePath,
  performOperation,
  handleDependencyFilter,
} from "./utils";
import RoleModal from "./DistrictModal/RoleModals";
import HDCModal from "./Honorary District Chief/HDCModal";
import ReactiveModal from "./Reactive/Reactivate";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import PaginationForMobile from "../../../components/common/new/Pagination/PaginationForMobile";

const LOADER_DELAY = 1000;
const PAGE = "page";

const intialPaginationState = {
  currentPage: 0,
  totalPages: 0,
  totalElements: 0,
  pageSize: Constants.DEFAULT_PAGE_SIZE,
};
const filterOrder = [
  "areaId",
  "clusterId",
  "zoneId",
  "regionId",
  "chapterId",
  "districtId",
  "blockId",
];

function MemberSearch() {
  const TITLE = "Member Search - BSG";
  const [searchData, setSearchData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [paginationInfo, setPaginationInfo] = useState(intialPaginationState);
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openModalHelpDesk, setOpenModalHelpDesk] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const formRef = useRef(null);
  const allowModalRef = useRef(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const metaData = useSelector((state) => state.meta);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const {
    isHelpDesk,
    isChapterSi,
    isHelpDeskAdmin,
    isAreaSi,
    isClusterSi,
    isZoneSi,
  } = useSelector(selectAllSIUsers);
  const hasPermission = useUserConfig();
  const { getQueryObject, getQueryParams, urlSearchParams } = useQueryParams();
  const [totalElements, setTotalElements] = useState(0);
  const [openRoleModal, setOpenRoleModal] = useState(false);
  const [openHDCModal, setOpenHDCModal] = useState(false);
  const [openReactivateModal, setOpenReactivateModal] = useState(false);
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  const [openResultModal, setOpenResultModal] = useState(false); // Full-width modal open
  const [, setShowSearchResult] = useState(false); // Whether search attempted
  const [filterKey, setFilterKey] = useState(0);

  const onModalToggle = () => setOpenModal((prev) => !prev);
  const onModalToggleHelpDesk = () => setOpenModalHelpDesk((prev) => !prev);
  const onReactiveModalToggle = () => setOpenReactivateModal((prev) => !prev);
  const toast = useContext(ToastAlertContext);

  const isMobile = useMediaQuery("(max-width: 768px)");

  const updatePaginationInfo = (pagination) => {
    setPaginationInfo({
      currentPage: pagination.number,
      totalPages: pagination.totalPages,
      totalElements: pagination.totalElements,
      pageSize: pagination.size,
    });
  };

  const clearFormRef = () => {
    if (formRef.current) {
      formRef.current.reset();
    }
  };

  const resetFormState = () => {
    setSearchData([]);
    setAppliedFilters([]);
    setPaginationInfo(intialPaginationState);
    setFilterKey((prev) => prev + 1);
    clearFormRef();
  };

  const initializeFormState = (queryObject) => {
    if (!isEmptyObj(queryObject)) {
      clearFormRef();
      Object.keys(queryObject).forEach((key) => {
        if (formRef.current[key]) {
          formRef.current[key].value = queryObject[key];
        }
      });
    }
  };

  const updateSearchParam = (query) => {
    if (query?.length) {
      navigate(`${getRoutePath()}?${query}`);
    } else {
      navigate(`${getRoutePath()}`);
    }
  };

  const validateAndFetchData = (formattedQuery, toast, setIsLoading) => {
    if (
      formattedQuery.specialGroupAppointments &&
      !formattedQuery.mainlinePositionIds &&
      !formattedQuery.dualPositionIds
    ) {
      toast.show("Please select the Mainline Positions", AlertStatus.ERROR);
      setIsLoading(false);
      return false;
    }

    return true;
  };

  const fetchSearchData = async (queryParams, params = {}) => {
    try {
      setIsLoading(true);
      const formattedQuery = getFormattedQuery(queryParams);

      if (validateAndFetchData(formattedQuery, toast, setIsLoading)) {
        const { data } = await Member.search(formattedQuery, params);

        setTimeout(() => {
          setSearchData(data.content);
          updatePaginationInfo(data);
          setIsLoading(false);
          setShowSearchResult(true);
          setTotalElements(data.totalElements);

          if (data.totalElements === 0) {
            toast.show("No data found", AlertStatus.ERROR);
            allowModalRef.current = false; // modal open block
            return;
          }

          // ✅ अगर data मिला तभी modal खुले
          if (allowModalRef.current) {
            setOpenResultModal(true);
            allowModalRef.current = false;
          }
        }, LOADER_DELAY);
      }
    } catch (error) {
      setIsLoading(false);
      allowModalRef.current = false; // safety reset on error
      Sentry.captureException(error);
    }
  };

  const handleGoBackToSearch = () => {
    setOpenResultModal(false); // Close modal
    allowModalRef.current = false; // safety
  };

  const orderedFilters = filterOrder
    .map((filterKey) =>
      appliedFilters.find((filter) => filter.key === filterKey)
    )
    .filter(Boolean);

  const additionalFilters = appliedFilters.filter(
    (filter) => !filterOrder.includes(filter.key)
  );

  const handleResetAndClose = () => {
    setSearchData([]);
    setAppliedFilters([]);
    setPaginationInfo(intialPaginationState);
    setFilterKey((prev) => prev + 1); // 👈 remount trigger
    clearFormRef();
    updateSearchParam();
    setShowSearchResult(false);
    setOpenResultModal(false);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setPaginationInfo(intialPaginationState);

    // Extract form values using formRef
    const rawFormData = new FormData(formRef.current);
    const formData = formDataToObject(rawFormData);

    // ✅ check: no filter selected
    const hasAnyFilter = Object.values(formData).some(
      (val) => val && val.toString().trim() !== ""
    );
    if (!hasAnyFilter) {
      toast.show("Please select your search filter", AlertStatus.WARNING);
      return;
    }

    const query = queryString.stringify(formData);

    // Close all popover
    document.dispatchEvent(new Event(EVENT_NAME));

    // ✅ Mark: user-initiated search
    allowModalRef.current = true;

    // ✅ URL update (pagination/history ke liye)
    updateSearchParam(query);

    fetchSearchData(formData);
  };

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const [query, params] = getQueryParams(queryObject);
      fetchSearchData(query, params);
      initializeFormState(query);
    } else {
      resetFormState();
    }
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];

      // ✅ pageNumber/pageSize ko hatao AppliedFilters ke liye
      const cleanedQuery = { ...query };
      delete cleanedQuery.pageNumber;
      delete cleanedQuery.pageSize;

      setAppliedFilters(
        getFilters(cleanedQuery, metaData, disabledOSKeys || [])
      );
    } else {
      setAppliedFilters([]);
    }
  }, [metaData, urlSearchParams.toString()]);

  const onPaginationClick = (clickedNumber) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      page: clickedNumber,
    });
    updateSearchParam(queryParams);
  };

  const onPageSizeClick = (operator) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      page: 0,
      pageSize: queryObject.pageSize
        ? performOperation(
            queryObject.pageSize,
            Constants.DEFAULT_PAGE_SIZE,
            operator
          )
        : 2 * Constants.DEFAULT_PAGE_SIZE,
    });
    updateSearchParam(queryParams);
  };

  const onSelectMemberForTransfer = (member) => {
    dispatch({
      type: SET_SELECTED_MEMBER_TRANSFER,
      payload: member,
    });
    navigate(ROUTES.MEMBER_TRANSFER_REQUEST.path);
  };

  const onSelectMember = (member) => {
    navigate(`/${ROUTES.MEMBER_DETAIL.path}/${member.memberId}`);
  };
  const onSelectMemberForMobile = (member) => {
    navigate(`/${ROUTES.MEMBER_DETAIL_FOR_MOBILE.path}/${member.memberId}`);
  };

  const onMemberStatusToggle = (member) => {
    setSelectedMember(member);
    onModalToggle();
  };

  const onMemberStatusToggleForHelpDesk = (member) => {
    setSelectedMember(member);
    onModalToggleHelpDesk();
  };

  const onMemberReactivateToggle = (member) => {
    setSelectedMember(member);
    onReactiveModalToggle();
  };

  const getTitle = () =>
    selectedMember?.status === ACTIVE
      ? "Reason for deactivating the user?"
      : "Reactivation";

  const onRefresh = () => {
    const queryObject = getQueryObject();
    const [query, params] = getQueryParams(queryObject);
    fetchSearchData(query, params);
  };
  const removeKeyFromQuery = (queryObject, filterKey) => {
    let updatedQuery = {
      ...queryObject,
      pageNumber: 0,
      pageSize: Constants.DEFAULT_PAGE_SIZE,
    };

    if (DATES.includes(filterKey)) {
      delete updatedQuery[filterKey];
      delete updatedQuery[`${filterKey.split("From")[0]}To`];
    } else {
      delete updatedQuery[filterKey];
    }
    updatedQuery = handleDependencyFilter(updatedQuery, disabledOSKeys);

    if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
      delete updatedQuery[PAGE];
    }

    // handle dependency filter
    updatedQuery = handleDependencyFilter(updatedQuery, disabledOSKeys);

    return updatedQuery;
  };

  const onRemoveFilter = (filterKey) => {
    let queryObject = getQueryObject();
    queryObject = removeKeyFromQuery(queryObject, filterKey);

    // ✅ check: agar sirf pagination keys bachi hain → filters khali
    const { pageNumber, pageSize, ...rest } = queryObject;
    if (isEmptyObj(rest)) {
      handleResetAndClose(); // modal close + filters reset
      return;
    }

    const updatedQuery = queryString.stringify(queryObject);
    updateSearchParam(updatedQuery);
  };

  const onEdit = (row) => {
    setSelectedMember(row);
    setOpenRoleModal(true);
  };

  const closeRoleModal = () => {
    setOpenRoleModal(false);
  };

  const onToggleHDC = (row) => {
    setSelectedMember(row);
    setOpenHDCModal(true);
  };
  const closeHDCModal = () => {
    setOpenHDCModal(false);
  };

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <div
        style={{
          ...styles.container,
          // ...(isMobile && { minHeight: "1100px", overflowY: "scroll" }),
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1px",
          }}
        >
          <Button
            onClick={handleResetAndClose}
            variant="outlined"
            color="secondary"
            sx={{
              textTransform: "none",
              height: "20px",
              fontSize: "13px",
              fontWeight: "600",
              marginRight: "10px",
              width: "85px",
              padding: "0px !important",
            }}
          >
            Clear Filters
          </Button>
        </div>
        <div style={styles.filter}>
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "3px",
              width: "100%",
            }}
            onSubmit={onSubmit}
            ref={formRef}
          >
            {/* Organization Structure */}
            <div
              style={{
                paddingLeft: isMobile ? "20px" : "0px",
                marginBottom: "0px",
              }}
            >
              <div style={{ fontWeight: "600", marginBottom: "10px" }}>
                Organization Structure
              </div>
              <OrganizationSearch
                key={`org-${filterKey}`}
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
              />
            </div>
            {/* Personal Details */}
            <div
              style={{
                paddingLeft: isMobile ? "20px" : "0px",
                marginBottom: "5px",
              }}
            >
              <div style={{ fontWeight: "600", marginBottom: "12px" }}>
                Search by Personal Details
              </div>
              <PersonalDetailsSearch
                key={`personal-${filterKey}`}
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
              />
            </div>

            {/* Submit Button */}
            {/* ✅ Desktop ke liye (sirf desktop me dikhega, mobile me hide ho jayega) */}
            {!isMobile && (
              <div
                style={{
                  paddingLeft: "",
                  paddingRight: "",
                  alignSelf: "end",
                  marginTop: "10px",
                  marginRight: "5px",
                }}
              >
                <Button type="submit" variant="contained" color="primary">
                  Search
                </Button>
              </div>
            )}

            {/* Advanced Search Section */}
            <div
              style={{
                paddingLeft: isMobile ? "20px" : "",
                marginBottom: isMobile ? "5px" : "5px",
                paddingTop: isMobile ? "10px" : "",
                paddingBottom: isMobile ? "20px" : "",
              }}
            >
              <div
                onClick={() => setShowAdvancedSearch((prev) => !prev)}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  fontWeight: "600",
                  marginBottom: "8px",
                  fontSize: "16px",
                  gap: "8px",
                }}
              >
                <span>{showAdvancedSearch ? "−" : "+"}</span>
                <span>Advanced Search</span>
              </div>

              {showAdvancedSearch && (
                <div style={{ paddingBottom: isMobile ? "20px" : "0px" }}>
                  <AdvancedSearch
                    key={`advanced-${filterKey}`}
                    formRef={formRef}
                    disabledOSKeys={disabledOSKeys}
                  />
                </div>
              )}

              {/* ✅ Mobile ke liye button */}
              {isMobile && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    paddingLeft: "5px",
                    paddingRight: "10px",
                    paddingTop: "5px",
                    marginTop: "30px",
                    marginRight: "15px",
                    paddingBottom: "100px",
                  }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{
                      width: "100%",
                    }}
                  >
                    Search
                  </Button>
                </div>
              )}
            </div>
          </form>
        </div>
        {/* Mobile separator border */}
        {isMobile && (
          <div
            style={{
              borderTop: "2px solid #ffffffff",
              paddingTop: "10px",
              paddingBottom: "10px",
              marginTop: "10px",
            }}
          />
        )}
        {isLoading && <Loader />}
        <Modal
          open={openModal}
          onClose={onModalToggle}
          title={getTitle()}
          customStyle={{
            maxHeight: "98%",
            overflowY: "auto",
            maxWidth: "100%",
          }}
        >
          <MemberToggleStatus
            selectedMember={selectedMember}
            onClose={onModalToggle}
            callBack={onRefresh}
          />
        </Modal>
        <Modal
          open={openResultModal}
          onClose={handleGoBackToSearch}
          title="Search Results"
          customStyle={{
            marginTop: "30px",
            width: "98%",
            maxWidth: "100%",
            height: "90%",
            maxHeight: "100%",
            overflowY: "auto",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            padding: "0px 10px 2px 10px",
            position: "relative",
          }}
        >
          {isLoading ? (
            <Loader />
          ) : searchData.length > 0 ? (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "10px",
                  fontWeight: 600,
                  fontSize: 13,
                  marginBottom: "0px",
                  paddingBottom: "0px",
                  borderBottom: "1px solid #eee",
                }}
              >
                {/* Left cluster: Total + Filters */}
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    minWidth: 260,
                    gap: 10,
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ flex: "0 0 auto" }}>
                    Total Members: {totalElements}
                  </div>

                  {appliedFilters.length > 0 && (
                    <div style={{ flex: 1, minWidth: 200 }}>
                      <div style={styles.filterWrapper}>
                        <div style={styles.filterContainer}>
                          {orderedFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                          {additionalFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Right: Clear + Back */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flexWrap: "wrap",
                    flex: "0 0 auto",
                  }}
                >
                  <Button
                    onClick={handleResetAndClose}
                    variant="outlined"
                    color="secondary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                      minWidth: "100px",
                    }}
                  >
                    Clear Filters
                  </Button>
                  <Button
                    onClick={handleGoBackToSearch}
                    variant="contained"
                    color="primary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                    }}
                  >
                    Back
                  </Button>
                </div>
              </div>

              <div style={{ flex: 1, overflowX: "auto", marginTop: "15px" }}>
                <MemberTable
                  searchData={searchData}
                  onSelectMemberForTransfer={onSelectMemberForTransfer}
                  onSelectMember={onSelectMember}
                  onSelectMemberForMobile={onSelectMemberForMobile}
                  hasPermission={hasPermission}
                  onMemberStatusToggle={onMemberStatusToggle}
                  onMemberStatusToggleForHelpDesk={
                    onMemberStatusToggleForHelpDesk
                  }
                  onMemberReactivateToggle={onMemberReactivateToggle}
                  showStatusColumn={isHelpDesk || isHelpDeskAdmin}
                  onEdit={onEdit}
                  onToggleHDC={onToggleHDC}
                  isChapterSi={isChapterSi}
                  isHelpDesk={isHelpDesk}
                  isAreaSi={isAreaSi}
                  isClusterSi={isClusterSi}
                  isZoneSi={isZoneSi}
                  isHelpDeskAdmin={isHelpDeskAdmin}
                  isMobile={isMobile}
                />
              </div>
              <div style={{ marginTop: "20px" }}>
                {isMobile ? (
                  <PaginationForMobile
                    totalPages={paginationInfo.totalPages}
                    totalResults={paginationInfo.totalElements}
                    currentPage={paginationInfo.currentPage}
                    pageSize={paginationInfo.pageSize}
                    onChange={onPaginationClick}
                    onPageSizeClick={onPageSizeClick}
                  />
                ) : (
                  <Pagination
                    totalPages={paginationInfo.totalPages}
                    totalResults={paginationInfo.totalElements}
                    currentPage={paginationInfo.currentPage}
                    pageSize={paginationInfo.pageSize}
                    onChange={onPaginationClick}
                    onPageSizeClick={onPageSizeClick}
                  />
                )}
              </div>
            </>
          ) : null}
        </Modal>

        <Modal
          open={openModalHelpDesk}
          onClose={onModalToggleHelpDesk}
          title={getTitle()}
          customStyle={{
            maxHeight: "98%",
            overflowY: "auto",
            maxWidth: "100%",
          }}
        >
          <MemberDirectDeactivationHelpDesk
            selectedMember={selectedMember}
            onClose={onModalToggleHelpDesk}
            callBack={onRefresh}
          />
        </Modal>
        <Modal
          open={openReactivateModal}
          onClose={onReactiveModalToggle}
          title={getTitle()}
        >
          <ReactiveModal
            selectedMember={selectedMember}
            onClose={onReactiveModalToggle}
            callBack={onRefresh}
          />
        </Modal>
        <Modal
          open={openRoleModal}
          onClose={closeRoleModal}
          title="Roles"
          customStyle={{ minWidth: "30%" }}
        >
          <RoleModal
            open={openRoleModal}
            selectedMember={selectedMember}
            onClose={closeRoleModal}
            callBack={onRefresh}
            isChapterSi={isChapterSi}
          />
        </Modal>
        <Modal
          open={openHDCModal}
          onClose={closeHDCModal}
          title="Honorary District Chief"
          customStyle={{
            maxHeight: "98%",
            overflowY: "auto",
            maxWidth: "98%",
          }}
        >
          <HDCModal
            open={openHDCModal}
            selectedMember={selectedMember}
            onClose={closeHDCModal}
          />
        </Modal>
      </div>
    </>
  );
}

export default MemberSearch;
